import angular from 'angular';
import serviceModule from './service/module';

angular
    .module('paysera.environment', [
        serviceModule
    ])
;

export default 'paysera.environment';
